import { useState } from 'react';
import { describeLeases } from '@shared/external-writes/describe';
import { isProduction } from '../../lib/environment';
import { ExternalWritesPopover } from './ExternalWritesPopover';
import { useExternalWrites } from './useExternalWrites';

/**
 * Banner shown on every authenticated route while any external system is
 * leased live. Owns the state sync (fetch, focus, expiry timer) for the
 * shared store.
 */
export function ExternalWritesBanner() {
  const { state } = useExternalWrites({ sync: true });
  const [open, setOpen] = useState(false);

  if (isProduction() || state === 'unknown') return null;
  const described = describeLeases(state, new Date());
  if (described.tone === 'none') return null;

  const toneClass =
    described.tone === 'red'
      ? 'bg-bg-danger-inverse text-content-inverse'
      : 'bg-bg-warning-inverse text-content-inverse';

  return (
    <>
      <div
        role="status"
        aria-label="External writes are live"
        className={`fixed left-1/2 top-2 z-[9998] flex max-w-[90vw] -translate-x-1/2 items-center gap-3 rounded-full px-4 py-1.5 text-xs font-semibold shadow-lg ${toneClass}`}
      >
        <span>{described.headline}</span>
        {described.sandboxedLine && <span className="font-normal">{described.sandboxedLine}</span>}
        <button type="button" className="underline" onClick={() => setOpen((v) => !v)}>
          Manage
        </button>
      </div>
      {open && <ExternalWritesPopover onClose={() => setOpen(false)} />}
    </>
  );
}
